import { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { clsx } from 'clsx';

type Props = {
  value: string;
  label?: string;
  className?: string;
};

// Kleiner Copy-to-Clipboard-Button mit kurzer "kopiert"-Bestaetigung.
// Genutzt neben ISBN-Anzeigen — Mitarbeiter spielen die ISBN danach
// in BiblioXL ein.
export function CopyButton({ value, label, className }: Props) {
  const [copied, setCopied] = useState(false);

  async function copy(): Promise<void> {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard kann auf nicht-HTTPS / aelteren Browsern fehlen —
      // Fallback ueber ein temporaeres Textarea.
      const ta = document.createElement('textarea');
      ta.value = value;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      } catch {
        /* aufgeben — kein Clipboard verfuegbar */
      }
      document.body.removeChild(ta);
    }
  }

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        void copy();
      }}
      aria-label={copied ? 'Kopiert' : (label ?? `${value} kopieren`)}
      title={copied ? 'Kopiert' : (label ?? 'Kopieren')}
      className={clsx(
        'touch-ziel inline-flex h-7 w-7 items-center justify-center rounded text-ink-faint transition-colors hover:bg-cream-dark hover:text-akzent',
        className
      )}
    >
      {copied ? <Check className="h-3.5 w-3.5 text-teal" /> : <Copy className="h-3.5 w-3.5" />}
    </button>
  );
}
